import {  NgModule } from '@angular/core';
import { AcessoGovBrBronzeComponent } from './acesso-gov-br-bronze.component';
import { AcessoGovBrBronzeRoutingModule } from './acesso-gov-br-bronze.routing,module';

@NgModule({
  imports: [AcessoGovBrBronzeRoutingModule],
  declarations: [
  AcessoGovBrBronzeComponent
  ]
})
export class AcessoGovBrBronzeModule {}
